export default __webpack_public_path__ + "static/media/illustration_carrier-contract-negotiation.c1d4a549.svg";